import { getColors } from '../../../Constants';
import './IconText.css';

type Props = {
    text: string;
    icon?: string;
    className?: string;
    highlightSubString?: string;
    mutedSubString?: string;
    iconAndHighlightColor?: string;
};

// Currently supports only material-symbols-rounded icons
const IconText = ({
    text,
    icon,
    className,
    highlightSubString,
    mutedSubString,
    iconAndHighlightColor = getColors().primary,
}: Props) => {
    const highlightColorStyle = iconAndHighlightColor ? { color: iconAndHighlightColor } : {};

    const parts = [];
    let remainingText = text;

    while (remainingText) {
        const highlightIndex = highlightSubString
            ? remainingText.toLowerCase().indexOf(highlightSubString.toLowerCase())
            : -1;
        const mutedIndex = mutedSubString ? remainingText.toLowerCase().indexOf(mutedSubString.toLowerCase()) : -1;

        if (highlightIndex === -1 && mutedIndex === -1) {
            parts.push(remainingText);
            break;
        }

        const nextIndex =
            highlightIndex !== -1 && (highlightIndex < mutedIndex || mutedIndex === -1) ? highlightIndex : mutedIndex;
        const nextSubstring = nextIndex === highlightIndex ? highlightSubString : mutedSubString;
        const nextStyle = nextIndex === highlightIndex ? highlightColorStyle : {};
        const nextClass = nextIndex === highlightIndex ? 'highlightedText' : 'mutedText';

        if (nextIndex > 0) {
            parts.push(remainingText.slice(0, nextIndex));
        }

        parts.push(
            <span key={parts.length} className={nextClass} style={nextStyle}>
                {nextSubstring && remainingText.slice(nextIndex, nextIndex + nextSubstring.length)}
            </span>
        );

        if (nextSubstring) {
            remainingText = remainingText.slice(nextIndex + nextSubstring.length);
        } else {
            break;
        }
    }

    return (
        <p className={`icon-text ${className || ''}`} style={{ color: 'inherit' }}>
            <span className='material-symbols-rounded' style={highlightColorStyle}>
                {icon}
            </span>
            <span className="icon-text__content">
                {parts.map((part, index) =>
                    typeof part === 'string' ? <span key={index}>{part}</span> : part
                )}
            </span>
        </p>
    );
};

export default IconText;
